import React, { useEffect, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import '@videojs/themes/dist/fantasy/index.css';

const VideoJS = (props) => {
  const videoRef = useRef(null);
  const { options, onReady } = props;

  useEffect(() => {
    // Initialize Video.js
    const player = videojs(videoRef.current, options, () => {
      if (onReady) {
        onReady(player);
      }
    });

    // Cleanup function to dispose of the player
    return () => {
      if (player) {
        player.dispose();
      }
    };
  }, [videoRef, options, onReady]);

  return (
    <div>
      <div data-vjs-player>
        <video ref={videoRef} className="video-js vjs-theme-fantasy vjs-big-play-centered" />
      </div>
    </div>
  );
};

export default VideoJS;